export enum ChartType {
  BarChart = "BarChart",
  Sankey = "Sankey",
}